module.exports = __webpack_public_path__ + "img/antigua-and-barbuda.219f9aa7.png";